import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";

export const useWorkflowQuery = (shopId: string, workflowId: string) => {
  const query = $api.useQuery("get", "/shops/{shopId}/workflows/{workflowId}", {
    params: { path: { shopId, workflowId } },
  });
  return query;
};

export const useInvalidateWorkflowQuery = ({
  shopId,
  workflowId,
}: {
  shopId: string;
  workflowId: string;
}) => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: [
        "get",
        "/shops/{shopId}/workflows/{workflowId}",
        { params: { path: { shopId, workflowId } } },
      ],
    });
  };
};
